import React from "react";
import PageLayout from "../../components/layouts/PageLayout";
import CustomNavbar from "../../components/common/CustomNavbar";
import WhatsAppProfileView from "./WhatsAppProfileView";

const MetaProfile = () => {
  return (
    <PageLayout
      customNavbar={
        <CustomNavbar>
          <div className="flex gap-3 items-center w-max">
            <span className="font-bold text-lg uppercase">Meta profile</span>
          </div>
        </CustomNavbar>
      }
    >
      <WhatsAppProfileView />
    </PageLayout>
  );
};

export default MetaProfile;